export const bundles = [
  {
    "bundleId": 241,
    "displayName": "Mystic Blue Peak Lapel Suit",
    "cost": 139,
    "shortDescription": "With the Mystic Blue Peak Lapel Suit, we paired modern color and traditional style to create a bold new take on a classic navy. You will never feel like the status quo in this wedding suit as it features, Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits. Customize your wedding suit and make it yours.",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 1036,
        "displayable": false,
        "catalogName": "Mystic Blue Peak Lapel Suit",
        "catalogNumber": "130935MYB",
        "description": "Jacket, Modern, SB, Peak Lapel, 1 Bttn, Side Vent, Mystic Blue",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 1046,
        "displayable": false,
        "catalogName": "Mystic Blue Peak Lapel Suit Pant",
        "catalogNumber": "230945MYB",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Mystic Blue",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": "Solid",
        "costToCustomer": 50,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1541077441_visualizer-mystic_blue-suit_jacket_peak_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1523286740_130935MYB-visulaizer-jacket-full-202.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541077435_visualizer-mystic_blue-suit_jacket_peak_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1584383972_130935MYB-PeakSuit-FrontA-edit.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1584387497_130935MYB-PeakSuit-FrontB-edit.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1584387537_130935MYB-PeakSuit-QuarterA-edit.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286928_130935MYB-PeakSuit-BackB.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1584384047_130935MYB-PeakSuit-Main-Color-Editpsd.jpg",
        "label": "JACKET_FRONT_LOOK"
      }
    ]
  },
  {
    "bundleId": 114,
    "displayName": "Navy Blue Notch Lapel Suit",
    "cost": 139,
    "shortDescription": "Navy blue is the perfect formal suit choice for any occasion. This men's suit can be worn any time of year, with a wide variety of accessory colors both bright and soft. Our Navy Blue Notch Lapel Suit features Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits. Black or brown shoes can be work depending on accessory color. Customize your navy blue wedding suit and make it yours. ",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 209,
        "displayable": false,
        "catalogName": "Navy Blue Notch Lapel Suit Pant",
        "catalogNumber": "230136BLU",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Blue",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 144,
        "displayable": false,
        "catalogName": "Navy Blue Notch Lapel Suit",
        "catalogNumber": "130071BLU",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Pick Stitch, Blue",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286737_130071BLU-visulaizer-jacket-full-190.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541079298_visualizer-navy_blue-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541079306_visualizer-navy_blue-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1584384442_130071BLU-NotchSuit-FrontA-Edit.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1584384506_130071BLU-NotchSuit-FrontC-Edit.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1584384581_130071BLU-NotchSuit-QuarterB-Edit.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286914_130071BLU-NotchSuit-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1584384555_130071BLU-NotchSuit-Main-Accessory-Edit.jpg",
        "label": "JACKET_FRONT_LOOK"
      }
    ]
  },
  {
    "bundleId": 112,
    "displayName": "Gray Sharkskin Notch Lapel Suit",
    "cost": 139,
    "shortDescription": "Our Gray Sharkskin Suit is a nod to timeless stylings. Perfect for any time of year the suit features Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits. Feel free to wear black or brown shoes, just make sure that the accessories match. Start customizing your wedding suit rental and create the perfect look today. ",
    "type": "suit",
    "color": "Grey",
    "products": [
      {
        "id": 208,
        "displayable": false,
        "catalogName": "Gray Sharkskin Notch Lapel Suit Pant",
        "catalogNumber": "230135BLW",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Black & White",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 143,
        "displayable": false,
        "catalogName": "Gray Sharkskin Notch Lapel Suit",
        "catalogNumber": "130070BLW",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Pick Stitch, Black & White",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1551973779_130070BLW-NotchSuit-FrontA-Plum.png",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1551973927_130070BLW-NotchSuit-FrontC-Plum.png",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1551973960_130070BLW-NotchSuit-QuarterD-Plum.png",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286934_130070BLW-NotchSuit-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1551973991_130070BLW-NotchSuit-Main-Plum.png",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286737_130070BLW-visulaizer-jacket-full-162.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541077214_visualizer-gray_sharkskin-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541077220_visualizer-gray_sharkskin-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 246,
    "displayName": "Bright Blue Notch Lapel Suit",
    "cost": 139,
    "shortDescription": "No matter if it is dressed up or down, in the Bright Blue Notch Lapel Suit, you will be dressed to impress. Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits. Add the matching blue suit vest. You will thank us when you shed the jacket from all the heat you bring. Brown or black shoes are welcome on the dance floor, just make sure the tie matches accordingly. Customize your wedding suit and create the perfect look for your big day.",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 1565,
        "displayable": false,
        "catalogName": "Bright Blue Notch Lapel Suit Jacket",
        "catalogNumber": "131409BBC",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Bright Blue Crepe",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 1567,
        "displayable": false,
        "catalogName": "Bright Blue Suit Pant",
        "catalogNumber": "231411BBC",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Bright Blue Crepe",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286923_131409BBC-NotchSuit-FrontD.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286924_131409BBC-NotchSuit-FrontC.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286924_131409BBC-NotchSuit-FrontB.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286925_131409BBC-NotchSuit-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286925_131409BBC-NotchSuit-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286741_131409BBC-visulaizer-jacket-full-183.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541077504_visualizer-bright_blue-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541077512_visualizer-bright_blue-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 242,
    "displayName": "Iron Gray Peak Lapel Suit",
    "cost": 139,
    "shortDescription": "Gray is a fresh choice for any occasion. Our single-button Iron Gray Peak Lapel Suit gives you a blank canvas to dress up or down as you see fit. Wear black or brown men's shoes and be confident in any accessory choice. This single-button suit features Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits. Start customizing your iron gray wedding suit and make it yours.",
    "type": "suit",
    "color": "Grey",
    "products": [
      {
        "id": 1038,
        "displayable": false,
        "catalogName": "Iron Gray Peak Lapel Suit",
        "catalogNumber": "130937IGR",
        "description": "Jacket, Modern, SB, Peak Lapel, 1 Bttn, Side Vent, Iron Grey",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 1048,
        "displayable": false,
        "catalogName": "Iron Gray Peak Lapel Suit Pant",
        "catalogNumber": "230947IGR",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Iron Grey",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286740_130937IGR-visulaizer-jacket-full-202.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541080539_visualizer-solid-IGR-iron_gray-suit-suit_jacket_peak_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541080547_visualizer-solid-IGR-iron_gray-suit-suit_jacket_peak_lapel-masked-fs8.png",
        "label": "VISUALIZER_JACKET_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1583859000_130937IGR-PeakSuit-FrontA-Edit.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1583859037_130937IGR-PeakSuit-FrontC-Edit.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1583859057_130937IGR-PeakSuit-QuarterA-Edit.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286931_130937IGR-PeakSuit-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1583859083_130937IGR-PeakSuit-Main-color edit.jpg",
        "label": "JACKET_FRONT_LOOK"
      }
    ]
  },
  {
    "bundleId": 249,
    "displayName": "Slate Blue Notch Lapel Suit",
    "cost": 139,
    "shortDescription": "Sophisticated styling is not just a catchphrase. With the Slate Blue Notch Lapel Suit, we prove that it is real. With this suit we wanted to find a line between our Mystic collection and classic navy suiting. We know we delivered. With super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits you are sure to make a lasting impression. Start customizing your wedding suit and creating the perfect look for your big day. ",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 1561,
        "displayable": false,
        "catalogName": "Slate Blue Notch Lapel Suit",
        "catalogNumber": "131405SLB",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Slate Blue",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 1563,
        "displayable": false,
        "catalogName": "Slate Blue Suit Pant",
        "catalogNumber": "231407SLB",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Slate Blue",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286741_131405SLB-visulaizer-jacket-full-183.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541077535_visualizer-slate_blue-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541077542_visualizer-slate_blue-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1584391025_131405SLB-NotchSuit-Main-Color-Edit.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1584391090_131405SLB-NotchSuit-FrontB-TieEdit.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1584391047_131405SLB-NotchSuit-QuarterA-TieEdit.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1551974503_131405SLB-NotchSuit-BackA-BlackSocks.png",
        "label": "PDP_Alt3"
      }
    ]
  },
  {
    "bundleId": 123,
    "displayName": "Charcoal Notch Lapel Suit",
    "cost": 139,
    "shortDescription": "Looking for a softer choice, but still want to keep it formal? Gain attention and look great with our Charcoal Gray Notch Lapel Suit. Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits. No matter the time or location, gray is a versatile style for any occasion. Customize your charcoal wedding suit and make it your perfect look. ",
    "type": "suit",
    "color": "Grey",
    "products": [
      {
        "id": 657,
        "displayable": false,
        "catalogName": "Charcoal Notch Lapel Suit Pant",
        "catalogNumber": "230652CHA",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Charcoal",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 145,
        "displayable": false,
        "catalogName": "Charcoal Notch Lapel Suit",
        "catalogNumber": "130072CHA",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Pick Stitch, Charcoal",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1551974637_140932CHA-NotchSuit-FrontA-Sangria-Wine.png",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1551974659_140932CHA-NotchSuit-FrontC-Sangria-Wine.png",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1551974681_140932CHA-NotchSuit-QuarterA-Sangria-Wine.png",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286908_140932CHA-NotchSuit-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1551974706_140932CHA-NotchSuit-Main-Sangria-Wine.png",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286737_130072CHA-visulaizer-jacket-full-190.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541077298_visualizer-charcoal-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541077304_visualizer-charcoal-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 253,
    "displayName": "Cement Gray Notch Lapel Suit",
    "cost": 139,
    "shortDescription": "The Cement Gray Notch Lapel Suit. Do not let the name fool you. It is easy to move on the dance floor when you look this good. Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits. Afterall, gray is the new neutral. Make this gray wedding suit rental yours by customizing your look. ",
    "type": "suit",
    "color": "Grey",
    "products": [
      {
        "id": 1622,
        "displayable": false,
        "catalogName": "Cement Gray Suit Jacket",
        "catalogNumber": "131466CMT",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Cement",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286851_131466CMT-visualizer-jacket-full-1066.jpg",
            "label": "VISUALIZER_JACKET_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1523286851_131466CMT-visualizer-jacket-front-1066.png",
            "label": "VISUALIZER_JACKET_FRONT"
          }
        ]
      },
      {
        "id": 1626,
        "displayable": false,
        "catalogName": "Cement Gray Suit Pant",
        "catalogNumber": "231470CMT",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Cement",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286946_131466CMT-NotchSuit-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286946_131466CMT-NotchSuit-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286947_131466CMT-NotchSuit-FrontB.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286947_131466CMT-NotchSuit-FrontC.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286948_131466CMT-NotchSuit-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286948_131466CMT-NotchSuit-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286851_131466CMT-visualizer-jacket-full-1066.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541077166_visualizer-cement_gray-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541077172_visualizer-cement_gray-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 111,
    "displayName": "Black Notch Lapel Suit",
    "cost": 139,
    "shortDescription": "Impeccably put together, our classic two-button Black Notch Lapel Suit is the perfect look for any evening. Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits ensure your event will be as timeless as the style. Start customizing your black wedding suit and create a timeless look for your big day.  ",
    "type": "suit",
    "color": "Black",
    "products": [
      {
        "id": 207,
        "displayable": false,
        "catalogName": "Black Notch Lapel Suit Pant",
        "catalogNumber": "230134BLK",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Black",
        "colorGroup": "Black",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523292041_Outfit-7-Pant_2358_RT_ME.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523292042_Outfit-7-Pant_2357_RT_ME2.png",
            "label": "PDP_Alt1"
          }
        ]
      },
      {
        "id": 142,
        "displayable": false,
        "catalogName": "Black Notch Lapel Suit",
        "catalogNumber": "130069BLK",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Pick Stitch, Black",
        "colorGroup": "Black",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286901_130069BLK-NotchSuit-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286902_130069BLK-NotchSuit-FrontB.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286902_130069BLK-NotchSuit-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286902_130069BLK-NotchSuit-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286903_130069BLK-NotchSuit-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286736_130069BLK-visulaizer-jacket-full-190.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541076902_visualizer-black-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541076910_visualizer-black-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 115,
    "displayName": "Tan Sharkskin Notch Lapel Suit",
    "cost": 89,
    "shortDescription": "Swim differently in a sea of normality. Designed for daytime or warm climate events our Tan Sharkskin Notch Lapel Suit is sure to catch attention. Super 130’s Merino wool, flat front pants and sizing available in modern fit. Feel free to show some courage and some pop by adding bold accessories. Start customizing your tan wedding suit rental and create the perfect formal look. ",
    "type": "suit",
    "color": "Tan",
    "products": [
      {
        "id": 146,
        "displayable": false,
        "catalogName": "Tan Sharkskin Notch Lapel Suit",
        "catalogNumber": "130073TAN",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Pick Stitch, Tan",
        "colorGroup": "Tan",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 39,
        "media": []
      },
      {
        "id": 214,
        "displayable": false,
        "catalogName": "Tan Sharkskin Notch Lapel Suit Pant",
        "catalogNumber": "230141TAN",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Tan",
        "colorGroup": "Tan",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286938_130073TAN-NotchSuit-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286938_130073TAN-NotchSuit-FrontB.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286939_130073TAN-NotchSuit-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286940_130073TAN-NotchSuit-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286940_130073TAN-NotchSuit-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286738_130073TAN-visulaizer-jacket-full-162.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541016250_visualizer-tan_sharkskin-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541016260_visualizer-tan_sharkskin-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 255,
    "displayName": "Indigo Blue Notch Lapel Suit",
    "cost": 139,
    "shortDescription": "Kick things up a notch with our Indigo Blue Notch Lapel Suit. The wool, silk and linen blend is a lightweight compromise when it comes to formalwear. We recommend neutral accessories, so not to overpower the look. Start customizing your blue wedding suit and be her, \"something blue\". ",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 1624,
        "displayable": false,
        "catalogName": "Indigo Blue Suit Jacket",
        "catalogNumber": "131468BLC",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Blue Chambray",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286852_131468BLC-visualizer-jacket-front-1068.png",
            "label": "VISUALIZER_JACKET_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1523286852_131468BLC-visualizer-jacket-full-1068.jpg",
            "label": "VISUALIZER_JACKET_FULL"
          }
        ]
      },
      {
        "id": 1628,
        "displayable": false,
        "catalogName": "Indigo Blue Suit Pant",
        "catalogNumber": "231472BLC",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Blue Chambray",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": "Solid",
        "costToCustomer": 50,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286944_131468BLC-NotchSuit-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286943_131468BLC-NotchSuit-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286945_131468BLC-NotchSuit-FrontB.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286951_131468BLC-NotchSuit-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286953_131468BLC-NotchSuit-QuarterA.jpg",
        "label": "PDP_Alt4"
      },
      {
        "url": "https://gentux.imgix.net/1523286852_131468BLC-visualizer-jacket-full-1068.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541077331_visualizer-indigo_blue-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541077338_visualizer-indigo_blue-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 247,
    "displayName": "Light Gray Plaid Notch Lapel Suit",
    "cost": 139,
    "shortDescription": "Boardroom or beachside, the Light Gray Plaid Notch Lapel Suit will not disappoint. Our design boasts a gray plaid ombre pattern, Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits. The wool crepe creates a flattering drape that will make anyone feel like a million bucks. Customize your plaid wedding suit with our suit builder and bring your style to life.",
    "type": "suit",
    "color": "Grey",
    "products": [
      {
        "id": 1557,
        "displayable": false,
        "catalogName": "Light Gray Plaid Notch Lapel Suit Jacket",
        "catalogNumber": "131401LGC",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Light Grey Crepe",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Plaid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 1559,
        "displayable": false,
        "catalogName": "Light Gray Suit Pant",
        "catalogNumber": "231403LGC",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Light Grey Crepe",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286935_131401LGC-PlaidNotchSuit-FrontB.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286936_131401LGC-PlaidNotchSuit-FrontA.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286936_131401LGC-PlaidNotchSuit-FrontC.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286937_131401LGC-PlaidNotchSuit-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286937_131401LGC-PlaidNotchSuit-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286741_131401LGC-visulaizer-jacket-full-171.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541077066_visualizer-light_gray_plaid-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541077073_visualizer-light_gray_plaid-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 250,
    "displayName": "Oxford Navy Blazer",
    "cost": 69,
    "shortDescription": "The Oxford Navy Blazer can be dressed up or down. This men's blazer pairs with our Tan Sharkskin pants, which comes with the rental, to create a classic yet versatile look. Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits. Always brown shoes with the Oxford Blazer. Always. Start customizing your wedding suit and create the perfect look for your big day. ",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 1569,
        "displayable": false,
        "catalogName": "Oxford Navy Blazer",
        "catalogNumber": "131413NYH",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Navy Hopsack",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 19,
        "media": []
      },
      {
        "id": 214,
        "displayable": false,
        "catalogName": "Tan Sharkskin Notch Lapel Suit Pant",
        "catalogNumber": "230141TAN",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Tan",
        "colorGroup": "Tan",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286909_131413NYH-OxfordBlazer-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286910_131413NYH-OxfordBlazer-FrontB.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286910_131413NYH-OxfordBlazer-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286911_131413NYH-OxfordBlazer-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286911_131413NYH-OxfordBlazer-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286742_131413NYH-visulaizer-jacket-full-125.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541079335_visualizer-navy-blazer-suit_jacket_notch_lapel-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541079346_visualizer-navy-blazer-suit_jacket_notch_lapel-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 116,
    "displayName": "Black Notch Lapel Tuxedo",
    "cost": 139,
    "shortDescription": "James Bond references have been done, but you will never be. At least not in our Black Notch Lapel Tuxedo. Contemporary. Confident. And comfortable. Super 140’s Merino wool, flat front pants and sizing available in both modern and slim fits. Be glad looks can not kill. Start customizing your black wedding tuxedo and create a timeless look that will never go out of style. ",
    "type": "tuxedo",
    "color": "Black",
    "products": [
      {
        "id": 147,
        "displayable": false,
        "catalogName": "Black Notch Lapel Tux Jacket",
        "catalogNumber": "130074BLK",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Tuxedo, Black",
        "colorGroup": "Black",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 212,
        "displayable": false,
        "catalogName": "Black Tux Pant",
        "catalogNumber": "230139BLK",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Satin Stripe, Black",
        "colorGroup": "Black",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523292108_230139BLK_BLACK_TUX_MODERN_PANT_Front_Black.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523292107_230139BLK_BLACK_TUX_MODERN_PANT_Back_Black.png",
            "label": "PDP_Alt1"
          }
        ]
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286876_130074BLK-NotchTux-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286877_130074BLK-NotchTux-FrontB.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286878_130074BLK-NotchTux-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286878_130074BLK-NotchTux-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286879_130074BLK-NotchTux-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286738_130074BLK-visulaizer-jacket-full-072.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541079586_visualizer-black-notch-tux_jacket-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541079593_visualizer-black-notch-tux_jacket-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 119,
    "displayName": "Black Peak Lapel Tuxedo",
    "cost": 139,
    "shortDescription": "Our Black Peak Lapel Tuxedo puts the form in formal. They say peak lapels can add inches to height, so stand tall and stand out in a timeless styling. Featuring, Super 140’s Merino wool, flat front pants and sizing available in both modern and slim tuxedo fits. Customize your peak tuxedo rental and create your perfect look. ",
    "type": "tuxedo",
    "color": "Black",
    "products": [
      {
        "id": 212,
        "displayable": false,
        "catalogName": "Black Tux Pant",
        "catalogNumber": "230139BLK",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Satin Stripe, Black",
        "colorGroup": "Black",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523292108_230139BLK_BLACK_TUX_MODERN_PANT_Front_Black.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523292107_230139BLK_BLACK_TUX_MODERN_PANT_Back_Black.png",
            "label": "PDP_Alt1"
          }
        ]
      },
      {
        "id": 148,
        "displayable": false,
        "catalogName": "Black Peak Lapel Tux Jacket",
        "catalogNumber": "130075BLK",
        "description": "Jacket, Modern, SB, Peak Lapel, 1 Bttn, Side Vent, Tuxedo, Black",
        "colorGroup": "Black",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286885_130075BLK-PeakTux-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286886_130075BLK-PeakTux-FrontC.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286886_130075BLK-PeakTux-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286886_130075BLK-PeakTux-BackA.jpg",
        "label": "PDP_Alt5"
      },
      {
        "url": "https://gentux.imgix.net/1523286887_130075BLK-PeakTux-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286738_130075BLK-visulaizer-jacket-full-050.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541079552_visualizer-black-peak-tux_jacket-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541079559_visualizer-black-peak-tux_jacket-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 102,
    "displayName": "Midnight Blue Peak Lapel Tuxedo",
    "cost": 139,
    "shortDescription": "Our Midnight Blue Peak Lapel Tuxedo features Super 140's Merino wool, black satin-faced peak lapels, and vents accommodating both modern and slim fits. Add a bespoke lining story and you create a unique and infamous look. An excellent choice for any black tie wedding or affair. The pictures will prove it for years to come. Customize your midnight blue wedding tuxedo and create a timeless look for your big day. ",
    "type": "tuxedo",
    "color": "Blue",
    "products": [
      {
        "id": 149,
        "displayable": false,
        "catalogName": "Midnight Blue Peak Lapel Tux Jacket",
        "catalogNumber": "130076MDT",
        "description": "Jacket, Modern, SB, Peak Lapel, 1 Bttn, Side Vent, Tuxedo, Midnight",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 213,
        "displayable": false,
        "catalogName": "Midnight Blue Peak Lapel Tux Pant",
        "catalogNumber": "230140MDT",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Satin Stripe, Midnight",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": "Solid",
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523291971_230140MDT_1-1_Pant_Front_Tux_Midnight.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523285151_230140MDT_1-1_Pant_Back_Tux_Midnight.png",
            "label": "PDP_Alt1"
          }
        ]
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286893_230140MDT-PeakTux-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286894_230140MDT-PeakTux-FrontB.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286894_230140MDT-PeakTux-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286895_230140MDT-PeakTux-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286895_230140MDT-PeakTux-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286739_130076MDT-visulaizer-jacket-full-050.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541079680_visualizer-midnight_blue-peak-tux_jacket-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541079686_visualizer-midnight_blue-peak-tux_jacket-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 120,
    "displayName": "Charcoal Gray Notch Lapel Tuxedo",
    "cost": 139,
    "shortDescription": "You don’t need to wear black to dress up. Change your tone with our Charcoal Gray Tuxedo Rental. Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits. This grey notch lapel tuxedo is the perfect style for any time of year.",
    "type": "tuxedo",
    "color": "Grey",
    "products": [
      {
        "id": 210,
        "displayable": false,
        "catalogName": "Charcoal Gray Notch Lapel Tux Pant",
        "catalogNumber": "230137CHA",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Charcoal",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 137,
        "displayable": false,
        "catalogName": "Charcoal Gray Notch Lapel Tux",
        "catalogNumber": "130064CHA",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent W/Contrast Piping, Tuxedo, Charcoal",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286896_130064CHA-NotchTux-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286896_130064CHA-NotchTux-FrontB.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286897_130064CHA-NotchTux-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286897_130064CHA-NotchTux-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286898_130064CHA-NotchTux-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286736_130064CHA-visulaizer-jacket-full-100.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541079650_visualizer-charcoal_gray-notch-tux_jacket-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541079656_visualizer-charcoal_gray-notch-tux_jacket-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 106,
    "displayName": "Light Gray Notch Lapel Tuxedo",
    "cost": 139,
    "shortDescription": "Fall, Winter, Spring or Summer. It doesn’t matter. Our Light Gray Notch Lapel Tuxedo is versatile elegance. With Super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits all you need is the perfect accessory. Bold, neutral or pattern you will not go wrong with this gray tuxedo rental, and feel free to rock black or brown shoes. Start customizing your gray wedding tuxedo now and ensure that you reserve your perfect look. ",
    "type": "tuxedo",
    "color": "Grey",
    "products": [
      {
        "id": 138,
        "displayable": false,
        "catalogName": "Light Gray Notch Lapel Tux Jacket",
        "catalogNumber": "130065LGY",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent W/Contrast Piping, Tuxedo, Light Gray",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 211,
        "displayable": false,
        "catalogName": "Light Gray Notch Lapel Tux Pant",
        "catalogNumber": "230138LGY",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Light Gray",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523291969_230138LGY_2-1_Pant_Back_Notch_Tux_LightGray.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523291969_230138LGY_2-1_Pant_Back_Notch_Tux_LightGray.png",
            "label": "PDP_Alt1"
          }
        ]
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286890_230138LGY-NotchTux-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286891_230138LGY-NotchTux-QuarterA.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286892_230138LGY-NotchTux-QuarterB.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286892_230138LGY-NotchTux-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286893_230138LGY-NotchTux-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286736_130065LGY-visulaizer-jacket-full-119.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541079617_visualizer-light_gray-notch-tux_jacket-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541079623_visualizer-light_gray-notch-tux_jacket-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 118,
    "displayName": "Black Shawl Lapel Tuxedo",
    "cost": 139,
    "shortDescription": "Modern elegance. Nothing says it quite like our Black Shawl Lapel Tuxedo. Be confident, sleek and composed. Featuring our Super 140’s Merino wool and flat front pants. Sizing available in both modern and slim fits. Customize your black wedding tuxedo and create the perfect style for your big day.",
    "type": "tuxedo",
    "color": "Black",
    "products": [
      {
        "id": 153,
        "displayable": false,
        "catalogName": "Black Shawl Lapel Tux Jacket",
        "catalogNumber": "130080BLK",
        "description": "Jacket, Modern, SB, Shawl Collar, 1 Bttn, Side Vent, Tuxedo, Black",
        "colorGroup": "Black",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 212,
        "displayable": false,
        "catalogName": "Black Tux Pant",
        "catalogNumber": "230139BLK",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Satin Stripe, Black",
        "colorGroup": "Black",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523292108_230139BLK_BLACK_TUX_MODERN_PANT_Front_Black.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523292107_230139BLK_BLACK_TUX_MODERN_PANT_Back_Black.png",
            "label": "PDP_Alt1"
          }
        ]
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286880_130080BLK-ShawlTux-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286882_130080BLK-ShawlTux-QuarterB.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286883_130080BLK-ShawlTux-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286884_130080BLK-ShawlTux-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286884_130080BLK-ShawlTux-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286739_130080BLK-visulaizer-jacket-full-045.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541079515_visualizer-black-shawl-tux_jacket-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541079521_visualizer-black-shawl-tux_jacket-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 245,
    "displayName": "Mystic Blue Edge Lapel Tuxedo",
    "cost": 139,
    "shortDescription": "With the Mystic Blue Tuxedo, we chose to rise above the standard. Pairing modern color and traditional style to create a bold new take on a classic navy, you will never feel like the status quo. With super 130’s Merino wool, flat front pants and sizing available in both modern and slim fits; the tuxedo will photograph beautifully for any occasion. Start customizing your wedding tuxedo and create your perfect look.  ",
    "type": "tuxedo",
    "color": "Blue",
    "products": [
      {
        "id": 1547,
        "displayable": false,
        "catalogName": "Mystic Blue Notch Lapel Tuxedo Jacket",
        "catalogNumber": "131395MYB",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Tuxedo, Mystic Blue",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 1549,
        "displayable": false,
        "catalogName": "Mystic Blue Tuxedo Pant",
        "catalogNumber": "231397MYB",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Mystic Blue",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": "Solid",
        "costToCustomer": 50,
        "media": []
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286888_131395MYB-NotchTux-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286888_131395MYB-NotchTux-FrontD.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286889_131395MYB-NotchTux-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286889_131395MYB-NotchTux-Back.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286890_131395MYB-NotchTux-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286740_131395MYB-visulaizer-jacket-full-100.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541077476_visualizer-mystic_blue-notch-tux_jacket-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541077483_visualizer-mystic_blue-notch-tux_jacket-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 110,
    "displayName": "White Shawl Lapel Tuxedo",
    "cost": 89,
    "shortDescription": "Our White Shawl Lapel Tuxedo is the perfect choice for an event looking for some southern charm or late night cocktails in the city that never sleeps. The white tux jacket is a poly/wool blend with satin trim and is available in modern fit only. This men's white tuxedo rental comes with our black flat front pants for a timeless yet modern look. Start customizing your white wedding tuxedo and create the perfect look for your big day. \n",
    "type": "tuxedo",
    "color": "White",
    "products": [
      {
        "id": 154,
        "displayable": false,
        "catalogName": "White Shawl Lapel Jacket",
        "catalogNumber": "130081WHT",
        "description": "Jacket, Modern, SB, Shawl Collar, 1 Bttn, Side Vent, Tuxedo, White",
        "colorGroup": "White",
        "type": "Jacket",
        "pattern": null,
        "costToCustomer": 39,
        "media": []
      },
      {
        "id": 212,
        "displayable": false,
        "catalogName": "Black Tux Pant",
        "catalogNumber": "230139BLK",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Satin Stripe, Black",
        "colorGroup": "Black",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523292108_230139BLK_BLACK_TUX_MODERN_PANT_Front_Black.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523292107_230139BLK_BLACK_TUX_MODERN_PANT_Back_Black.png",
            "label": "PDP_Alt1"
          }
        ]
      }
    ],
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286899_130081WHT-ShawlTux-FrontA.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286899_130081WHT-ShawlTux-FrontB.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286900_130081WHT-ShawlTux-QuarterA.jpg",
        "label": "PDP_Alt2"
      },
      {
        "url": "https://gentux.imgix.net/1523286941_130081WHT-ShawlTux-BackA.jpg",
        "label": "PDP_Alt3"
      },
      {
        "url": "https://gentux.imgix.net/1523286900_130081WHT-ShawlTux-Main.jpg",
        "label": "JACKET_FRONT_LOOK"
      },
      {
        "url": "https://gentux.imgix.net/1523286740_130081WHT-visulaizer-jacket-full-025.jpg",
        "label": "VISUALIZER_JACKET_COLLECTION_VIEW"
      },
      {
        "url": "https://gentux.imgix.net/1541079480_visualizer-white-shawl-tux_jacket-un_masked.jpg",
        "label": "VISUALIZER_JACKET_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541079486_visualizer-white-shawl-tux_jacket-masked.png",
        "label": "VISUALIZER_JACKET_FRONT"
      }
    ]
  },
  {
    "bundleId": 277,
    "displayName": "RECOMMENDED Tan Sharkskin Notch Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Brown",
    "products": [
      {
        "id": 146,
        "displayable": false,
        "catalogName": "Tan Sharkskin Notch Lapel Suit",
        "catalogNumber": "130073TAN",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Pick Stitch, Tan",
        "colorGroup": "Tan",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 39,
        "media": []
      },
      {
        "id": 965,
        "displayable": false,
        "catalogName": "Tan Formal Socks",
        "catalogNumber": "810910TAN",
        "description": "Socks, Mens, Over The Calf, Formal, Tan",
        "colorGroup": "Tan",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539357370_20181009-150631-810910TAN_Sock_Laydown.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 956,
        "displayable": true,
        "catalogName": "Brown Belt with Silver Buckle",
        "catalogNumber": "B10903BWN",
        "description": "Belt, Mens, Belt, Brown",
        "colorGroup": "Brown",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187669_20181009-150631-B10903BWN_Belts_BRWN.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1064,
        "displayable": true,
        "catalogName": "Champagne Pocket Square",
        "catalogNumber": "610959CHM",
        "description": "Pocket Square, Mens, Solid, Champagne",
        "colorGroup": "Tan",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-CHM-champagne-pocket_square-181101162123.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          },
          {
            "url": "https://gentux.imgix.net/layflat-solid-CHM-champagne-pocket_square-181030161533.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 259,
        "displayable": true,
        "catalogName": "Brown Leather Dress Shoes",
        "catalogNumber": "A10186BRA",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Brown Antiqued",
        "colorGroup": "Brown",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1568841506_190806 - brown shoes GenTux.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1362,
        "displayable": true,
        "catalogName": "Champagne Pre-Tied Tie",
        "catalogNumber": "911239CHM",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Champagne",
        "colorGroup": "Tan",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286677_911239CHM-visualizer-tie-full-0495.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539623291_20181009-150631-911239CHM_PT_LongTie_Solid_Champagne.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 214,
        "displayable": false,
        "catalogName": "Tan Sharkskin Notch Lapel Suit Pant",
        "catalogNumber": "230141TAN",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Tan",
        "colorGroup": "Tan",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 70,
        "displayable": true,
        "catalogName": "Tan Sharkskin Suit Vest",
        "catalogNumber": "430469TAN",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Tan",
        "colorGroup": "Tan",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539307993_20181009-150631-430469TAN_Suit_Vest_Tan.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539307981_20181009-150631-430469TAN_Suit_Vest_Back_Tan.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541007985_visualizer_vest_front-solid-TAN-tan_sharkskin-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554830196_visualizer_vest_full-solid-TAN-tan_sharkskin-suit_vest-190405094121.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 259,
    "displayName": "RECOMMENDED Bright Blue Notch Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 1565,
        "displayable": false,
        "catalogName": "Bright Blue Notch Lapel Suit Jacket",
        "catalogNumber": "131409BBC",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Bright Blue Crepe",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 257,
        "displayable": true,
        "catalogName": "Black Dress Shoes",
        "catalogNumber": "A10184BMT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Matte",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539360706_20181009-150631-A10184BMT_Shoe_Matte_Black_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 666,
        "displayable": false,
        "catalogName": "Skinny Black Satin Tie",
        "catalogNumber": "940807BLK",
        "description": "Tie, Slim, Windsor Tie, Self Tied, Satin, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286711_930804BLK-visualizer-tie-full-0527.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539188033_20181009-150631-940807BLK_Tie_Laydown.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1567,
        "displayable": false,
        "catalogName": "Bright Blue Suit Pant",
        "catalogNumber": "231411BBC",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Bright Blue Crepe",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 1616,
        "displayable": true,
        "catalogName": "Bright Blue Suit Vest",
        "catalogNumber": "431460BBC",
        "description": "Vest, Modern, Suit, Lining Back, Bright Blue Crepe",
        "colorGroup": "Blue",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539341527_20181009-150631-431460BBC-BrightBlueCrepe_Vest_Front.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539341515_20181009-150631-431460BBC-BrightBlueCrepe_Vest_Back.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541009570_visualizer_vest_front-solid-BBC-bright_blue-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554830684_visualizer_vest_full-solid-BBC-bright_blue-suit_vest-190405095821.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 242,
        "displayable": true,
        "catalogName": "White Point Collar Shirt",
        "catalogNumber": "330169WHT",
        "description": "Shirt, Modern, Point Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539274004_181010-154803-shirt-white.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063522_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_point-190528115508-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063532_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_point-190528115515-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 75,
        "displayable": true,
        "catalogName": "Black Belt with Silver Buckle",
        "catalogNumber": "B10002BLK",
        "description": "Belt, Mens, Belt, Black",
        "colorGroup": "Black",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187720_20181009-150631-B10002BLK_Belts_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 261,
    "displayName": "RECOMMENDED Black Notch Lapel Tuxedo",
    "cost": 0,
    "shortDescription": "na",
    "type": "tuxedo",
    "color": "Black",
    "products": [
      {
        "id": 147,
        "displayable": false,
        "catalogName": "Black Notch Lapel Tux Jacket",
        "catalogNumber": "130074BLK",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Tuxedo, Black",
        "colorGroup": "Black",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 212,
        "displayable": false,
        "catalogName": "Black Tux Pant",
        "catalogNumber": "230139BLK",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Satin Stripe, Black",
        "colorGroup": "Black",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523292108_230139BLK_BLACK_TUX_MODERN_PANT_Front_Black.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523292107_230139BLK_BLACK_TUX_MODERN_PANT_Back_Black.png",
            "label": "PDP_Alt1"
          }
        ]
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 338,
        "displayable": true,
        "catalogName": "Black Pre-Tied Bow Tie",
        "catalogNumber": "910265BLK",
        "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286742_910265BLK-visualizer-tie-bow-0453.png",
            "label": "VISUALIZER_TIE_NO_STRAP"
          },
          {
            "url": "https://gentux.imgix.net/1539357442_20181009-150631-910265BLK_Solid_BowTie_PT_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 158,
        "displayable": true,
        "catalogName": "Black and Silver Cufflinks and Studs",
        "catalogNumber": "030085BLS",
        "description": "Cufflinks, Cuff Link, Black Plastic In Silver Metal, black/silver",
        "colorGroup": "Grey",
        "type": "Cufflinks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1583351762_product_render-cufflinks-original-silver-black-2020-03-04_11-20-00.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 258,
        "displayable": true,
        "catalogName": "Glossy Black Tuxedo Shoes",
        "catalogNumber": "A10185BPT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Patent",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539702152_20181009-150631-A10185BPT_Shoe_Patent_Leather_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 248,
        "displayable": true,
        "catalogName": "Pleated White Spread Collar Shirt",
        "catalogNumber": "330175WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Pleated Front, Convertible Cuff, LS, Poplin, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273898_181010-154803-shirt-white-pleated.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063881_visualizer_shirt_full-solid-WHT-white_pleated-shirt-shirt-collar_spread-190528114306-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063890_visualizer_shirt_collar-solid-WHT-white_pleated-shirt-shirt-collar_spread-190528114722-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 64,
        "displayable": true,
        "catalogName": "Black Tux Vest",
        "catalogNumber": "430463BLK",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Black",
        "colorGroup": "Black",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539296801_20181009-150631-430463BLK_Tux_Vest_Black.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539296794_20181009-150631-430463BLK_Tux_Vest_Back_Black.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541008653_visualizer_vest_front-solid-BLK-black-tux_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554830631_visualizer_vest_full-solid-BLK-black-tux_vest-190405101132.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 263,
    "displayName": "RECOMMENDED Indigo Blue Notch Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 956,
        "displayable": true,
        "catalogName": "Brown Belt with Silver Buckle",
        "catalogNumber": "B10903BWN",
        "description": "Belt, Mens, Belt, Brown",
        "colorGroup": "Brown",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187669_20181009-150631-B10903BWN_Belts_BRWN.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1624,
        "displayable": false,
        "catalogName": "Indigo Blue Suit Jacket",
        "catalogNumber": "131468BLC",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Blue Chambray",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286852_131468BLC-visualizer-jacket-front-1068.png",
            "label": "VISUALIZER_JACKET_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1523286852_131468BLC-visualizer-jacket-full-1068.jpg",
            "label": "VISUALIZER_JACKET_FULL"
          }
        ]
      },
      {
        "id": 1628,
        "displayable": false,
        "catalogName": "Indigo Blue Suit Pant",
        "catalogNumber": "231472BLC",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Blue Chambray",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": "Solid",
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 259,
        "displayable": true,
        "catalogName": "Brown Leather Dress Shoes",
        "catalogNumber": "A10186BRA",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Brown Antiqued",
        "colorGroup": "Brown",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1568841506_190806 - brown shoes GenTux.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1362,
        "displayable": true,
        "catalogName": "Champagne Pre-Tied Tie",
        "catalogNumber": "911239CHM",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Champagne",
        "colorGroup": "Tan",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286677_911239CHM-visualizer-tie-full-0495.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539623291_20181009-150631-911239CHM_PT_LongTie_Solid_Champagne.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1632,
        "displayable": true,
        "catalogName": "Indigo Blue Suit Vest",
        "catalogNumber": "431476BLC",
        "description": "Vest, Modern, Suit, Lining Back, 5 Button, Blue Chambray",
        "colorGroup": "Blue",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286834_431476BLC-vest-front-0962.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523286834_431476BLC-vest-back-0965.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541008479_visualizer_vest_front-solid-BLC-indigo_blue-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554830530_visualizer_vest_full-solid-BLC-indigo_blue-suit_vest-190405094511.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 262,
    "displayName": "RECOMMENDED Cement Gray Notch Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Grey",
    "products": [
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 257,
        "displayable": true,
        "catalogName": "Black Dress Shoes",
        "catalogNumber": "A10184BMT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Matte",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539360706_20181009-150631-A10184BMT_Shoe_Matte_Black_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1622,
        "displayable": false,
        "catalogName": "Cement Gray Suit Jacket",
        "catalogNumber": "131466CMT",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Cement",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286851_131466CMT-visualizer-jacket-full-1066.jpg",
            "label": "VISUALIZER_JACKET_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1523286851_131466CMT-visualizer-jacket-front-1066.png",
            "label": "VISUALIZER_JACKET_FRONT"
          }
        ]
      },
      {
        "id": 1626,
        "displayable": false,
        "catalogName": "Cement Gray Suit Pant",
        "catalogNumber": "231470CMT",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Cement",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 1630,
        "displayable": true,
        "catalogName": "Cement Gray Suit Vest",
        "catalogNumber": "431474CMT",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Cement",
        "colorGroup": "Grey",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286837_431474CMT-vest-front-0950.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523286836_431474CMT-vest-back-0953.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541008442_visualizer_vest_front-solid-CMT-cement_gray-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554830478_visualizer_vest_full-solid-CMT-cement_gray-suit_vest-190405095628.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 242,
        "displayable": true,
        "catalogName": "White Point Collar Shirt",
        "catalogNumber": "330169WHT",
        "description": "Shirt, Modern, Point Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539274004_181010-154803-shirt-white.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063522_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_point-190528115508-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063532_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_point-190528115515-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 374,
        "displayable": true,
        "catalogName": "Black Pre-Tied Tie",
        "catalogNumber": "910301BLK",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286673_910301BLK-visualizer-tie-full-0489.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539609259_20181009-150631-910301BLK_Solid_Solid_Long_PT_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 75,
        "displayable": true,
        "catalogName": "Black Belt with Silver Buckle",
        "catalogNumber": "B10002BLK",
        "description": "Belt, Mens, Belt, Black",
        "colorGroup": "Black",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187720_20181009-150631-B10002BLK_Belts_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 264,
    "displayName": "RECOMMENDED Light Gray Notch Lapel Tuxedo",
    "cost": 0,
    "shortDescription": "na",
    "type": "tuxedo",
    "color": "Grey",
    "products": [
      {
        "id": 68,
        "displayable": true,
        "catalogName": "Light Gray Tux Vest",
        "catalogNumber": "430467LGY",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Light Gray",
        "colorGroup": "Grey",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539307907_20181009-150631-430467LGY_Tuxedo_Vest_LtGray.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539307894_20181009-150631-430467LGY_Tuxedo_Vest_Back_LtGray.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541010441_visualizer_vest_front-solid-LGY-light_gray-tux_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554831256_visualizer_vest_full-solid-LGY-light_gray-tux_vest-190405100400.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 138,
        "displayable": false,
        "catalogName": "Light Gray Notch Lapel Tux Jacket",
        "catalogNumber": "130065LGY",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent W/Contrast Piping, Tuxedo, Light Gray",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 338,
        "displayable": true,
        "catalogName": "Black Pre-Tied Bow Tie",
        "catalogNumber": "910265BLK",
        "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286742_910265BLK-visualizer-tie-bow-0453.png",
            "label": "VISUALIZER_TIE_NO_STRAP"
          },
          {
            "url": "https://gentux.imgix.net/1539357442_20181009-150631-910265BLK_Solid_BowTie_PT_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 158,
        "displayable": true,
        "catalogName": "Black and Silver Cufflinks and Studs",
        "catalogNumber": "030085BLS",
        "description": "Cufflinks, Cuff Link, Black Plastic In Silver Metal, black/silver",
        "colorGroup": "Grey",
        "type": "Cufflinks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1583351762_product_render-cufflinks-original-silver-black-2020-03-04_11-20-00.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 258,
        "displayable": true,
        "catalogName": "Glossy Black Tuxedo Shoes",
        "catalogNumber": "A10185BPT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Patent",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539702152_20181009-150631-A10185BPT_Shoe_Patent_Leather_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 242,
        "displayable": true,
        "catalogName": "White Point Collar Shirt",
        "catalogNumber": "330169WHT",
        "description": "Shirt, Modern, Point Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539274004_181010-154803-shirt-white.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063522_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_point-190528115508-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063532_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_point-190528115515-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 211,
        "displayable": false,
        "catalogName": "Light Gray Notch Lapel Tux Pant",
        "catalogNumber": "230138LGY",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Light Gray",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523291969_230138LGY_2-1_Pant_Back_Notch_Tux_LightGray.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523291969_230138LGY_2-1_Pant_Back_Notch_Tux_LightGray.png",
            "label": "PDP_Alt1"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 265,
    "displayName": "RECOMMENDED Gray Sharkskin Notch Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Grey",
    "products": [
      {
        "id": 208,
        "displayable": false,
        "catalogName": "Gray Sharkskin Notch Lapel Suit Pant",
        "catalogNumber": "230135BLW",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Black & White",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 143,
        "displayable": false,
        "catalogName": "Gray Sharkskin Notch Lapel Suit",
        "catalogNumber": "130070BLW",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Pick Stitch, Black & White",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 257,
        "displayable": true,
        "catalogName": "Black Dress Shoes",
        "catalogNumber": "A10184BMT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Matte",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539360706_20181009-150631-A10184BMT_Shoe_Matte_Black_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 65,
        "displayable": true,
        "catalogName": "Gray Sharkskin Suit Vest",
        "catalogNumber": "430464BLW",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Black & White",
        "colorGroup": "Grey",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539307754_20181009-150631-430464BLW-Suit_Vest_Gray_Sharkskin.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539307742_20181009-150631-430464BLW-Suit_Vest_Back_Gray_Sharkskin.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541008715_visualizer_vest_front-solid-BLW-gray_sharkskin-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554830653_visualizer_vest_full-solid-BLW-gray_sharkskin-suit_vest-190405095243.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 75,
        "displayable": true,
        "catalogName": "Black Belt with Silver Buckle",
        "catalogNumber": "B10002BLK",
        "description": "Belt, Mens, Belt, Black",
        "colorGroup": "Black",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187720_20181009-150631-B10002BLK_Belts_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1369,
        "displayable": true,
        "catalogName": "Plum Pre-Tied Tie",
        "catalogNumber": "911246PLM",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Plum",
        "colorGroup": "Purple",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286669_911246PLM-visualizer-tie-full-0495.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539623544_20181009-150631-911246PLM_PT_LongTie_Solid_Plum.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 266,
    "displayName": "RECOMMENDED Navy Blue Notch Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 209,
        "displayable": false,
        "catalogName": "Navy Blue Notch Lapel Suit Pant",
        "catalogNumber": "230136BLU",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Blue",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 144,
        "displayable": false,
        "catalogName": "Navy Blue Notch Lapel Suit",
        "catalogNumber": "130071BLU",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Pick Stitch, Blue",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 257,
        "displayable": true,
        "catalogName": "Black Dress Shoes",
        "catalogNumber": "A10184BMT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Matte",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539360706_20181009-150631-A10184BMT_Shoe_Matte_Black_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 66,
        "displayable": true,
        "catalogName": "Navy Blue Suit Vest",
        "catalogNumber": "430465BLU",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Blue",
        "colorGroup": "Blue",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539307813_20181009-150631-430465BLU_Suit_Vest_Blue.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539307797_20181009-150631-430465BLU_Suit_Vest__Back_Blue.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541010485_visualizer_vest_front-solid-BLU-navy_blue-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554831292_visualizer_vest_full-solid-BLU-navy_blue-suit_vest-190405094857.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 75,
        "displayable": true,
        "catalogName": "Black Belt with Silver Buckle",
        "catalogNumber": "B10002BLK",
        "description": "Belt, Mens, Belt, Black",
        "colorGroup": "Black",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187720_20181009-150631-B10002BLK_Belts_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1663,
        "displayable": true,
        "catalogName": "Steel Blue Pre-Tied Tie",
        "catalogNumber": "911507STB",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Steel Blue",
        "colorGroup": "Blue",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286845_911507STB_Solid_Long_PT_Steel_Blue.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523286845_911507STB-tie-0493.png",
            "label": "VISUALIZER_TIE_FULL"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 267,
    "displayName": "RECOMMENDED Slate Blue Notch Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 257,
        "displayable": true,
        "catalogName": "Black Dress Shoes",
        "catalogNumber": "A10184BMT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Matte",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539360706_20181009-150631-A10184BMT_Shoe_Matte_Black_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1561,
        "displayable": false,
        "catalogName": "Slate Blue Notch Lapel Suit",
        "catalogNumber": "131405SLB",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Slate Blue",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 1563,
        "displayable": false,
        "catalogName": "Slate Blue Suit Pant",
        "catalogNumber": "231407SLB",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Slate Blue",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 1618,
        "displayable": true,
        "catalogName": "Slate Blue Suit Vest",
        "catalogNumber": "431462SLB",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Slate Blue",
        "colorGroup": "Blue",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286832_431462SLB-vest-front-0968.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523286833_431462SLB-vest-back-0977.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541010285_visualizer_vest_front-solid-SLB-slate_blue-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554831100_visualizer_vest_full-solid-SLB-slate_blue-suit_vest-190405095050.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 242,
        "displayable": true,
        "catalogName": "White Point Collar Shirt",
        "catalogNumber": "330169WHT",
        "description": "Shirt, Modern, Point Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539274004_181010-154803-shirt-white.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063522_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_point-190528115508-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063532_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_point-190528115515-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 75,
        "displayable": true,
        "catalogName": "Black Belt with Silver Buckle",
        "catalogNumber": "B10002BLK",
        "description": "Belt, Mens, Belt, Black",
        "colorGroup": "Black",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187720_20181009-150631-B10002BLK_Belts_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1374,
        "displayable": true,
        "catalogName": "Biscotti Pre-Tied Tie",
        "catalogNumber": "911249BIS",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Biscotti",
        "colorGroup": "Tan",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286680_911249BIS-visualizer-tie-full-0495.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539623621_20181009-150631-911249BIS_PT_LongTie_Solid_Biscotti.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 268,
    "displayName": "RECOMMENDED Light Gray Plaid Notch Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Grey",
    "products": [
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 956,
        "displayable": true,
        "catalogName": "Brown Belt with Silver Buckle",
        "catalogNumber": "B10903BWN",
        "description": "Belt, Mens, Belt, Brown",
        "colorGroup": "Brown",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187669_20181009-150631-B10903BWN_Belts_BRWN.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1072,
        "displayable": true,
        "catalogName": "Dark Navy Pocket Square",
        "catalogNumber": "610963DNV",
        "description": "Pocket Square, Mens, Solid, Dark Navy",
        "colorGroup": "Blue",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-DNV-dark_navy-pocket_square-181030160232.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-DNV-dark_navy-pocket_square-181101161633.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 1557,
        "displayable": false,
        "catalogName": "Light Gray Plaid Notch Lapel Suit Jacket",
        "catalogNumber": "131401LGC",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Light Grey Crepe",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Plaid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 1559,
        "displayable": false,
        "catalogName": "Light Gray Suit Pant",
        "catalogNumber": "231403LGC",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Light Grey Crepe",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 1617,
        "displayable": true,
        "catalogName": "Light Gray Plaid Suit Vest",
        "catalogNumber": "431461LGC",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Light Grey Crepe",
        "colorGroup": "Grey",
        "type": "Vest",
        "pattern": "Plaid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539341580_20181009-150631-431461LGC_Vest_LightGreyCrepe_Front.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539341569_20181009-150631-431461LGC_Vest_LightGreyCrepe_Back.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541008514_visualizer_vest_front-plaid-LGC-light_gray_plaid-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554830562_visualizer_vest_full-plaid-LGC-light_gray_plaid-suit_vest-190405094318.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 259,
        "displayable": true,
        "catalogName": "Brown Leather Dress Shoes",
        "catalogNumber": "A10186BRA",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Brown Antiqued",
        "colorGroup": "Brown",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1568841506_190806 - brown shoes GenTux.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1366,
        "displayable": true,
        "catalogName": "Dark Navy Pre-Tied Tie",
        "catalogNumber": "911243DNV",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Dark Navy",
        "colorGroup": "Blue",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286678_911243DNV-visualizer-tie-full-0495.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539623486_20181009-150631-911243DNV_PT_LongTie_Solid_DarkNavy.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 269,
    "displayName": "RECOMMENDED Black Shawl Lapel Tuxedo",
    "cost": 0,
    "shortDescription": "na",
    "type": "tuxedo",
    "color": "Black",
    "products": [
      {
        "id": 153,
        "displayable": false,
        "catalogName": "Black Shawl Lapel Tux Jacket",
        "catalogNumber": "130080BLK",
        "description": "Jacket, Modern, SB, Shawl Collar, 1 Bttn, Side Vent, Tuxedo, Black",
        "colorGroup": "Black",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 212,
        "displayable": false,
        "catalogName": "Black Tux Pant",
        "catalogNumber": "230139BLK",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Satin Stripe, Black",
        "colorGroup": "Black",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523292108_230139BLK_BLACK_TUX_MODERN_PANT_Front_Black.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523292107_230139BLK_BLACK_TUX_MODERN_PANT_Back_Black.png",
            "label": "PDP_Alt1"
          }
        ]
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 338,
        "displayable": true,
        "catalogName": "Black Pre-Tied Bow Tie",
        "catalogNumber": "910265BLK",
        "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286742_910265BLK-visualizer-tie-bow-0453.png",
            "label": "VISUALIZER_TIE_NO_STRAP"
          },
          {
            "url": "https://gentux.imgix.net/1539357442_20181009-150631-910265BLK_Solid_BowTie_PT_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 158,
        "displayable": true,
        "catalogName": "Black and Silver Cufflinks and Studs",
        "catalogNumber": "030085BLS",
        "description": "Cufflinks, Cuff Link, Black Plastic In Silver Metal, black/silver",
        "colorGroup": "Grey",
        "type": "Cufflinks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1583351762_product_render-cufflinks-original-silver-black-2020-03-04_11-20-00.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 258,
        "displayable": true,
        "catalogName": "Glossy Black Tuxedo Shoes",
        "catalogNumber": "A10185BPT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Patent",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539702152_20181009-150631-A10185BPT_Shoe_Patent_Leather_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 242,
        "displayable": true,
        "catalogName": "White Point Collar Shirt",
        "catalogNumber": "330169WHT",
        "description": "Shirt, Modern, Point Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539274004_181010-154803-shirt-white.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063522_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_point-190528115508-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063532_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_point-190528115515-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 64,
        "displayable": true,
        "catalogName": "Black Tux Vest",
        "catalogNumber": "430463BLK",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Black",
        "colorGroup": "Black",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539296801_20181009-150631-430463BLK_Tux_Vest_Black.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539296794_20181009-150631-430463BLK_Tux_Vest_Back_Black.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541008653_visualizer_vest_front-solid-BLK-black-tux_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554830631_visualizer_vest_full-solid-BLK-black-tux_vest-190405101132.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 274,
    "displayName": "RECOMMENDED Charcoal Gray Notch Lapel Tuxedo",
    "cost": 0,
    "shortDescription": "na",
    "type": "tuxedo",
    "color": "Grey",
    "products": [
      {
        "id": 67,
        "displayable": true,
        "catalogName": "Charcoal Tux Vest",
        "catalogNumber": "430466CHA",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Charcoal",
        "colorGroup": "Grey",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539307847_20181009-150631-430466CHA_Tux_Vest_Back_Charcoal.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1539307855_20181009-150631-430466CHA_Tux_Vest_Charcoal.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1541008627_visualizer_vest_front-solid-CHA-charcoal_gray-tux_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554830593_visualizer_vest_full-solid-CHA-charcoal_gray-tux_vest-190405100939.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 210,
        "displayable": false,
        "catalogName": "Charcoal Gray Notch Lapel Tux Pant",
        "catalogNumber": "230137CHA",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Charcoal",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 338,
        "displayable": true,
        "catalogName": "Black Pre-Tied Bow Tie",
        "catalogNumber": "910265BLK",
        "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286742_910265BLK-visualizer-tie-bow-0453.png",
            "label": "VISUALIZER_TIE_NO_STRAP"
          },
          {
            "url": "https://gentux.imgix.net/1539357442_20181009-150631-910265BLK_Solid_BowTie_PT_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 158,
        "displayable": true,
        "catalogName": "Black and Silver Cufflinks and Studs",
        "catalogNumber": "030085BLS",
        "description": "Cufflinks, Cuff Link, Black Plastic In Silver Metal, black/silver",
        "colorGroup": "Grey",
        "type": "Cufflinks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1583351762_product_render-cufflinks-original-silver-black-2020-03-04_11-20-00.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 137,
        "displayable": false,
        "catalogName": "Charcoal Gray Notch Lapel Tux",
        "catalogNumber": "130064CHA",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent W/Contrast Piping, Tuxedo, Charcoal",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 258,
        "displayable": true,
        "catalogName": "Glossy Black Tuxedo Shoes",
        "catalogNumber": "A10185BPT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Patent",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539702152_20181009-150631-A10185BPT_Shoe_Patent_Leather_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 270,
    "displayName": "RECOMMENDED Iron Gray Peak Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Black",
    "products": [
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 1038,
        "displayable": false,
        "catalogName": "Iron Gray Peak Lapel Suit",
        "catalogNumber": "130937IGR",
        "description": "Jacket, Modern, SB, Peak Lapel, 1 Bttn, Side Vent, Iron Grey",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 257,
        "displayable": true,
        "catalogName": "Black Dress Shoes",
        "catalogNumber": "A10184BMT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Matte",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539360706_20181009-150631-A10184BMT_Shoe_Matte_Black_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1048,
        "displayable": false,
        "catalogName": "Iron Gray Peak Lapel Suit Pant",
        "catalogNumber": "230947IGR",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Iron Grey",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 1055,
        "displayable": true,
        "catalogName": "Iron Gray Suit Vest",
        "catalogNumber": "430951IGR",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Iron Grey",
        "colorGroup": "Grey",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539341219_20181009-150631-430951IGR-Vest_Cummerbund-IronGrey_F.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539341210_20181009-150631-430951IGR-Vest_Cummerbund-IronGrey_B.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1554830865_visualizer_vest_full-solid-IGR-iron_gray-suit_vest-190405093928.png",
            "label": "VISUALIZER_VEST_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559055078_visualizer_vest_front-solid-IGR-iron_gray-suit_vest-20190528104603-fs8.png",
            "label": "VISUALIZER_VEST_FRONT"
          }
        ]
      },
      {
        "id": 242,
        "displayable": true,
        "catalogName": "White Point Collar Shirt",
        "catalogNumber": "330169WHT",
        "description": "Shirt, Modern, Point Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539274004_181010-154803-shirt-white.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063522_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_point-190528115508-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063532_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_point-190528115515-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 75,
        "displayable": true,
        "catalogName": "Black Belt with Silver Buckle",
        "catalogNumber": "B10002BLK",
        "description": "Belt, Mens, Belt, Black",
        "colorGroup": "Black",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187720_20181009-150631-B10002BLK_Belts_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1864,
        "displayable": true,
        "catalogName": "Petal Pink Solid Pre-Tied Tie",
        "catalogNumber": "911708PTP",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Petal Pink",
        "colorGroup": "Pink",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1542631902_layflat-solid-PTP-petal_pink-long_tie-181115161024.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523287168_visualizer-solid-PTP-long_tie-fs8.png",
            "label": "VISUALIZER_TIE_FULL"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 271,
    "displayName": "RECOMMENDED Charcoal Notch Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Grey",
    "products": [
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 657,
        "displayable": false,
        "catalogName": "Charcoal Notch Lapel Suit Pant",
        "catalogNumber": "230652CHA",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Charcoal",
        "colorGroup": "Grey",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 659,
        "displayable": true,
        "catalogName": "Charcoal Gray Suit Vest",
        "catalogNumber": "430654CHA",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Charcoal",
        "colorGroup": "Grey",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539308038_20181009-150631-430654CHA-Suit_Vest_Charcoal.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539308027_20181009-150631-430654CHA-Suit_Vest_Back_Charcoal.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541010409_visualizer_vest_front-solid-CHA-charcoal-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554831216_visualizer_vest_full-solid-CHA-charcoal-suit_vest-190405095435.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 145,
        "displayable": false,
        "catalogName": "Charcoal Notch Lapel Suit",
        "catalogNumber": "130072CHA",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Pick Stitch, Charcoal",
        "colorGroup": "Grey",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 257,
        "displayable": true,
        "catalogName": "Black Dress Shoes",
        "catalogNumber": "A10184BMT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Matte",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539360706_20181009-150631-A10184BMT_Shoe_Matte_Black_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 242,
        "displayable": true,
        "catalogName": "White Point Collar Shirt",
        "catalogNumber": "330169WHT",
        "description": "Shirt, Modern, Point Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539274004_181010-154803-shirt-white.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063522_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_point-190528115508-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063532_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_point-190528115515-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 75,
        "displayable": true,
        "catalogName": "Black Belt with Silver Buckle",
        "catalogNumber": "B10002BLK",
        "description": "Belt, Mens, Belt, Black",
        "colorGroup": "Black",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187720_20181009-150631-B10002BLK_Belts_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1363,
        "displayable": true,
        "catalogName": "Sangria Pre-Tied Tie",
        "catalogNumber": "911240SGA",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Wine",
        "colorGroup": "Red",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286678_911240WNE-visualizer-tie-full-0495.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539623429_20181009-150631-911240WNE_PT_LongTie_Solid_Wine.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 272,
    "displayName": "RECOMMENDED Black Notch Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Black",
    "products": [
      {
        "id": 207,
        "displayable": false,
        "catalogName": "Black Notch Lapel Suit Pant",
        "catalogNumber": "230134BLK",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Black",
        "colorGroup": "Black",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523292041_Outfit-7-Pant_2358_RT_ME.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523292042_Outfit-7-Pant_2357_RT_ME2.png",
            "label": "PDP_Alt1"
          }
        ]
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 660,
        "displayable": true,
        "catalogName": "Black Suit Vest",
        "catalogNumber": "430656BLK",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Black",
        "colorGroup": "Black",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539308084_20181009-150631-430656BLK_Suit_Vest_Black.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539308070_20181009-150631-430656BLK_Suit_Vest_Back_Black.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1554832574_visualizer_vest_front-solid-BLK-black-suit_vest-190405095920-fs8.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554832444_visualizer_vest_full-solid-BLK-black-suit_vest-190405100014.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 142,
        "displayable": false,
        "catalogName": "Black Notch Lapel Suit",
        "catalogNumber": "130069BLK",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Pick Stitch, Black",
        "colorGroup": "Black",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 257,
        "displayable": true,
        "catalogName": "Black Dress Shoes",
        "catalogNumber": "A10184BMT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Matte",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539360706_20181009-150631-A10184BMT_Shoe_Matte_Black_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 374,
        "displayable": true,
        "catalogName": "Black Pre-Tied Tie",
        "catalogNumber": "910301BLK",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286673_910301BLK-visualizer-tie-full-0489.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539609259_20181009-150631-910301BLK_Solid_Solid_Long_PT_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 75,
        "displayable": true,
        "catalogName": "Black Belt with Silver Buckle",
        "catalogNumber": "B10002BLK",
        "description": "Belt, Mens, Belt, Black",
        "colorGroup": "Black",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187720_20181009-150631-B10002BLK_Belts_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 273,
    "displayName": "RECOMMENDED Midnight Blue Peak Lapel Tuxedo",
    "cost": 0,
    "shortDescription": "na",
    "type": "tuxedo",
    "color": "Blue",
    "products": [
      {
        "id": 69,
        "displayable": true,
        "catalogName": "Midnight Blue Tux Vest",
        "catalogNumber": "430468MDT",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Midnight",
        "colorGroup": "Blue",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539307947_20181009-150631-430468MDT_Tux_Vest_Midnight.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539307938_20181009-150631-430468MDT_Tux_Vest_Back_Midnight.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541012243_visualizer_vest_front-solid-MDT-midnight_blue-tux_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554832930_visualizer_vest_full-solid-MDT-midnight_blue-tux_vest-190405100553.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 149,
        "displayable": false,
        "catalogName": "Midnight Blue Peak Lapel Tux Jacket",
        "catalogNumber": "130076MDT",
        "description": "Jacket, Modern, SB, Peak Lapel, 1 Bttn, Side Vent, Tuxedo, Midnight",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 338,
        "displayable": true,
        "catalogName": "Black Pre-Tied Bow Tie",
        "catalogNumber": "910265BLK",
        "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286742_910265BLK-visualizer-tie-bow-0453.png",
            "label": "VISUALIZER_TIE_NO_STRAP"
          },
          {
            "url": "https://gentux.imgix.net/1539357442_20181009-150631-910265BLK_Solid_BowTie_PT_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 158,
        "displayable": true,
        "catalogName": "Black and Silver Cufflinks and Studs",
        "catalogNumber": "030085BLS",
        "description": "Cufflinks, Cuff Link, Black Plastic In Silver Metal, black/silver",
        "colorGroup": "Grey",
        "type": "Cufflinks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1583351762_product_render-cufflinks-original-silver-black-2020-03-04_11-20-00.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 258,
        "displayable": true,
        "catalogName": "Glossy Black Tuxedo Shoes",
        "catalogNumber": "A10185BPT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Patent",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539702152_20181009-150631-A10185BPT_Shoe_Patent_Leather_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 213,
        "displayable": false,
        "catalogName": "Midnight Blue Peak Lapel Tux Pant",
        "catalogNumber": "230140MDT",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Satin Stripe, Midnight",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": "Solid",
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523291971_230140MDT_1-1_Pant_Front_Tux_Midnight.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523285151_230140MDT_1-1_Pant_Back_Tux_Midnight.png",
            "label": "PDP_Alt1"
          }
        ]
      },
      {
        "id": 242,
        "displayable": true,
        "catalogName": "White Point Collar Shirt",
        "catalogNumber": "330169WHT",
        "description": "Shirt, Modern, Point Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539274004_181010-154803-shirt-white.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063522_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_point-190528115508-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063532_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_point-190528115515-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 275,
    "displayName": "RECOMMENDED Black Peak Lapel Tuxedo",
    "cost": 0,
    "shortDescription": "na",
    "type": "tuxedo",
    "color": "Black",
    "products": [
      {
        "id": 212,
        "displayable": false,
        "catalogName": "Black Tux Pant",
        "catalogNumber": "230139BLK",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Satin Stripe, Black",
        "colorGroup": "Black",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523292108_230139BLK_BLACK_TUX_MODERN_PANT_Front_Black.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523292107_230139BLK_BLACK_TUX_MODERN_PANT_Back_Black.png",
            "label": "PDP_Alt1"
          }
        ]
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 338,
        "displayable": true,
        "catalogName": "Black Pre-Tied Bow Tie",
        "catalogNumber": "910265BLK",
        "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286742_910265BLK-visualizer-tie-bow-0453.png",
            "label": "VISUALIZER_TIE_NO_STRAP"
          },
          {
            "url": "https://gentux.imgix.net/1539357442_20181009-150631-910265BLK_Solid_BowTie_PT_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 158,
        "displayable": true,
        "catalogName": "Black and Silver Cufflinks and Studs",
        "catalogNumber": "030085BLS",
        "description": "Cufflinks, Cuff Link, Black Plastic In Silver Metal, black/silver",
        "colorGroup": "Grey",
        "type": "Cufflinks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1583351762_product_render-cufflinks-original-silver-black-2020-03-04_11-20-00.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 258,
        "displayable": true,
        "catalogName": "Glossy Black Tuxedo Shoes",
        "catalogNumber": "A10185BPT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Patent",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539702152_20181009-150631-A10185BPT_Shoe_Patent_Leather_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 64,
        "displayable": true,
        "catalogName": "Black Tux Vest",
        "catalogNumber": "430463BLK",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Black",
        "colorGroup": "Black",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539296801_20181009-150631-430463BLK_Tux_Vest_Black.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539296794_20181009-150631-430463BLK_Tux_Vest_Back_Black.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541008653_visualizer_vest_front-solid-BLK-black-tux_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554830631_visualizer_vest_full-solid-BLK-black-tux_vest-190405101132.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 148,
        "displayable": false,
        "catalogName": "Black Peak Lapel Tux Jacket",
        "catalogNumber": "130075BLK",
        "description": "Jacket, Modern, SB, Peak Lapel, 1 Bttn, Side Vent, Tuxedo, Black",
        "colorGroup": "Black",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      }
    ],
    "media": []
  },
  {
    "bundleId": 276,
    "displayName": "RECOMMENDED White Shawl Lapel Tuxedo",
    "cost": 0,
    "shortDescription": "na",
    "type": "tuxedo",
    "color": "White",
    "products": [
      {
        "id": 154,
        "displayable": false,
        "catalogName": "White Shawl Lapel Jacket",
        "catalogNumber": "130081WHT",
        "description": "Jacket, Modern, SB, Shawl Collar, 1 Bttn, Side Vent, Tuxedo, White",
        "colorGroup": "White",
        "type": "Jacket",
        "pattern": null,
        "costToCustomer": 39,
        "media": []
      },
      {
        "id": 212,
        "displayable": false,
        "catalogName": "Black Tux Pant",
        "catalogNumber": "230139BLK",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Satin Stripe, Black",
        "colorGroup": "Black",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523292108_230139BLK_BLACK_TUX_MODERN_PANT_Front_Black.png",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1523292107_230139BLK_BLACK_TUX_MODERN_PANT_Back_Black.png",
            "label": "PDP_Alt1"
          }
        ]
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 338,
        "displayable": true,
        "catalogName": "Black Pre-Tied Bow Tie",
        "catalogNumber": "910265BLK",
        "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286742_910265BLK-visualizer-tie-bow-0453.png",
            "label": "VISUALIZER_TIE_NO_STRAP"
          },
          {
            "url": "https://gentux.imgix.net/1539357442_20181009-150631-910265BLK_Solid_BowTie_PT_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 158,
        "displayable": true,
        "catalogName": "Black and Silver Cufflinks and Studs",
        "catalogNumber": "030085BLS",
        "description": "Cufflinks, Cuff Link, Black Plastic In Silver Metal, black/silver",
        "colorGroup": "Grey",
        "type": "Cufflinks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1583351762_product_render-cufflinks-original-silver-black-2020-03-04_11-20-00.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 258,
        "displayable": true,
        "catalogName": "Glossy Black Tuxedo Shoes",
        "catalogNumber": "A10185BPT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Patent",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539702152_20181009-150631-A10185BPT_Shoe_Patent_Leather_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 242,
        "displayable": true,
        "catalogName": "White Point Collar Shirt",
        "catalogNumber": "330169WHT",
        "description": "Shirt, Modern, Point Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539274004_181010-154803-shirt-white.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063522_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_point-190528115508-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063532_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_point-190528115515-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 278,
    "displayName": "RECOMMENDED Oxford Navy Blazer",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 965,
        "displayable": false,
        "catalogName": "Tan Formal Socks",
        "catalogNumber": "810910TAN",
        "description": "Socks, Mens, Over The Calf, Formal, Tan",
        "colorGroup": "Tan",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539357370_20181009-150631-810910TAN_Sock_Laydown.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 956,
        "displayable": true,
        "catalogName": "Brown Belt with Silver Buckle",
        "catalogNumber": "B10903BWN",
        "description": "Belt, Mens, Belt, Brown",
        "colorGroup": "Brown",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187669_20181009-150631-B10903BWN_Belts_BRWN.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1569,
        "displayable": false,
        "catalogName": "Oxford Navy Blazer",
        "catalogNumber": "131413NYH",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Navy Hopsack",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 19,
        "media": []
      },
      {
        "id": 259,
        "displayable": true,
        "catalogName": "Brown Leather Dress Shoes",
        "catalogNumber": "A10186BRA",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Brown Antiqued",
        "colorGroup": "Brown",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1568841506_190806 - brown shoes GenTux.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 214,
        "displayable": false,
        "catalogName": "Tan Sharkskin Notch Lapel Suit Pant",
        "catalogNumber": "230141TAN",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Tan",
        "colorGroup": "Tan",
        "type": "Pant",
        "pattern": null,
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 1429,
        "displayable": true,
        "catalogName": "Dark Navy Striped Pre-Tied Tie",
        "catalogNumber": "911298DNV",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Dark Navy",
        "colorGroup": "Blue",
        "type": "Tie",
        "pattern": "Striped",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286684_911298DNV-visualizer-tie-full-0510.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539624039_20181009-150631-911298DNV_PT_LongTie_Stripe_DarkNavy.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 256,
    "displayName": "RECOMMENDED Mystic Blue Peak Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 1057,
        "displayable": true,
        "catalogName": "Mystic Blue Suit Vest",
        "catalogNumber": "430953MYB",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Mystic Blue",
        "colorGroup": "Blue",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539341264_20181009-150631-430953MYB-Vest_Cummerbund-MysticBlue_F.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539341251_20181009-150631-430953MYB-Vest_Cummerbund-MysticBlue_B.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541008408_visualizer_vest_front-solid-MYB-mystic_blue-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554832984_visualizer_vest_full-solid-MYB-mystic_blue-suit_vest-190405093802.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 956,
        "displayable": true,
        "catalogName": "Brown Belt with Silver Buckle",
        "catalogNumber": "B10903BWN",
        "description": "Belt, Mens, Belt, Brown",
        "colorGroup": "Brown",
        "type": "Belt",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539187669_20181009-150631-B10903BWN_Belts_BRWN.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1036,
        "displayable": false,
        "catalogName": "Mystic Blue Peak Lapel Suit",
        "catalogNumber": "130935MYB",
        "description": "Jacket, Modern, SB, Peak Lapel, 1 Bttn, Side Vent, Mystic Blue",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 1046,
        "displayable": false,
        "catalogName": "Mystic Blue Peak Lapel Suit Pant",
        "catalogNumber": "230945MYB",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Mystic Blue",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": "Solid",
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 259,
        "displayable": true,
        "catalogName": "Brown Leather Dress Shoes",
        "catalogNumber": "A10186BRA",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Brown Antiqued",
        "colorGroup": "Brown",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1568841506_190806 - brown shoes GenTux.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1380,
        "displayable": true,
        "catalogName": "Portobello Pre-Tied Tie",
        "catalogNumber": "911253PRT",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Portobello",
        "colorGroup": "Tan",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286681_911253PRT-visualizer-tie-full-0495.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539623704_20181009-150631-911253PRT_PT_LongTie_Solid_Portobello.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  },
  {
    "bundleId": 257,
    "displayName": "RECOMMENDED Mystic Blue Edge Lapel Suit",
    "cost": 0,
    "shortDescription": "na",
    "type": "suit",
    "color": "Blue",
    "products": [
      {
        "id": 231,
        "displayable": true,
        "catalogName": "White Pocket Square",
        "catalogNumber": "610158WHT",
        "description": "Pocket Square, Mens, Solid, White",
        "colorGroup": "White",
        "type": "Pocket Square",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
            "label": "VISUALIZER_POCKET_SQUARE"
          }
        ]
      },
      {
        "id": 158,
        "displayable": true,
        "catalogName": "Black and Silver Cufflinks and Studs",
        "catalogNumber": "030085BLS",
        "description": "Cufflinks, Cuff Link, Black Plastic In Silver Metal, black/silver",
        "colorGroup": "Grey",
        "type": "Cufflinks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1583351762_product_render-cufflinks-original-silver-black-2020-03-04_11-20-00.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 286,
        "displayable": true,
        "catalogName": "Formal Black Socks",
        "catalogNumber": "810213BLK",
        "description": "Socks, Mens, Over The Calf, Formal, Black",
        "colorGroup": "Black",
        "type": "Socks",
        "pattern": "Solid",
        "costToCustomer": 0,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 975,
        "displayable": true,
        "catalogName": "White Twill Spread Collar Shirt",
        "catalogNumber": "330914WHT",
        "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
        "colorGroup": "White",
        "type": "Shirt",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
            "label": "VISUALIZER_SHIRT_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
            "label": "VISUALIZER_SHIRT_COLLAR"
          }
        ]
      },
      {
        "id": 258,
        "displayable": true,
        "catalogName": "Glossy Black Tuxedo Shoes",
        "catalogNumber": "A10185BPT",
        "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Patent",
        "colorGroup": "Black",
        "type": "Shoe",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539702152_20181009-150631-A10185BPT_Shoe_Patent_Leather_PVC.jpg",
            "label": "PDP_Hero"
          }
        ]
      },
      {
        "id": 1547,
        "displayable": false,
        "catalogName": "Mystic Blue Notch Lapel Tuxedo Jacket",
        "catalogNumber": "131395MYB",
        "description": "Jacket, Modern, SB, Notch Lapel, 2 Bttn, Side Vent, Tuxedo, Mystic Blue",
        "colorGroup": "Blue",
        "type": "Jacket",
        "pattern": "Solid",
        "costToCustomer": 89,
        "media": []
      },
      {
        "id": 1549,
        "displayable": false,
        "catalogName": "Mystic Blue Tuxedo Pant",
        "catalogNumber": "231397MYB",
        "description": "Pant, Modern, Flat Front, Slant Pocket, Adjustable Waist, Mystic Blue",
        "colorGroup": "Blue",
        "type": "Pant",
        "pattern": "Solid",
        "costToCustomer": 50,
        "media": []
      },
      {
        "id": 1555,
        "displayable": true,
        "catalogName": "Mystic Blue Edge Lapel Tux Vest",
        "catalogNumber": "431399MYB",
        "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Mystic Blue",
        "colorGroup": "Blue",
        "type": "Vest",
        "pattern": "Solid",
        "costToCustomer": 20,
        "media": [
          {
            "url": "https://gentux.imgix.net/1539341312_20181009-150631-431399MYB-MysticBlue_Vest_Front.jpg",
            "label": "PDP_Hero"
          },
          {
            "url": "https://gentux.imgix.net/1539341302_20181009-150631-431399MYB-MysticBlue_Vest_Back.jpg",
            "label": "PDP_Alt1"
          },
          {
            "url": "https://gentux.imgix.net/1541010239_visualizer_vest_front-solid-MYB-mystic_blue-suit_vest-1529086048.png",
            "label": "VISUALIZER_VEST_FRONT"
          },
          {
            "url": "https://gentux.imgix.net/1554831076_visualizer_vest_full-solid-MYB-mystic_blue-suit_vest-190405093802.png",
            "label": "VISUALIZER_VEST_FULL"
          }
        ]
      },
      {
        "id": 374,
        "displayable": true,
        "catalogName": "Black Pre-Tied Tie",
        "catalogNumber": "910301BLK",
        "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Black",
        "colorGroup": "Black",
        "type": "Tie",
        "pattern": "Solid",
        "costToCustomer": 10,
        "media": [
          {
            "url": "https://gentux.imgix.net/1523286673_910301BLK-visualizer-tie-full-0489.png",
            "label": "VISUALIZER_TIE_FULL"
          },
          {
            "url": "https://gentux.imgix.net/1539609259_20181009-150631-910301BLK_Solid_Solid_Long_PT_Black.jpg",
            "label": "PDP_Hero"
          }
        ]
      }
    ],
    "media": []
  }
];
